<template>
  <v-dialog
    v-model="$store.getters.getShowMessage"
    persistent
    min-height="200"
    max-width="300">
    <v-card>
      <v-card-title>
        <v-flex class="font-number-4 text-xs-center">{{ $store.getters.getMessage }}</v-flex>
      </v-card-title>
      <v-layout row wrap align-center>
        <v-flex xs4 />
        <v-flex xs4 text-xs-center>
          <v-progress-circular
            indeterminate
            :size="30"
            :width="5"
            color="primary" />
        </v-flex>
        <v-flex xs4 />
        <v-flex xs12>
          <br>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "MessageDialog"
};
</script>


// WEBPACK FOOTER //
// src/components/MessageDialog.vue